import React from "react";
import { useHistory } from "react-router-dom";
import application_icon from "@/assets/application_icon.svg";
import ic_Group from "@/assets/ic_Group.svg";
import { createTimeFormat } from "@/utils/timeFormat";
import {
	DescriptionSectionWrapper,
	DescriptionUnderContentDate,
	// DescriptionUnderContentDeadline,
	DescriptionUnderContentPlan,
	DescriptionUnderContentTitle,
	DescriptionUnderContentWrapper,
	DescriptionUnderWrapper,
	DescriptionUpperTitleImage,
	DescriptionUpperTitleText,
	DescriptionUpperTitleWrapper,
	DescriptionUpperWrapper,
	SettingButton,
} from "@/views/Application/Dashboard/style";
import { useSelector } from "react-redux";
import { getCurrentPlan } from "@/redux/organization/selector";
import CopyToClipboard from "react-copy-to-clipboard";
import clipboard from "@/assets/clipboard.svg";
import { useSnackbar } from "notistack";

interface IDescriptionSectionProps {
	dashboardObject: {
		id: number;
		name: string;
		planName: string;
		packageIos: string;
		packageAndroid: string;
		nextPaymentAt: string;
		createdAt: string;
		expiredAt: string;
		isUse: boolean;
		planCount: {
			startAt: string;
			endAt: string;
			count: number;
			maxCount: number;
		};
		monthCount: {
			startAt: string;
			endAt: string;
			count: number;
			maxCount: number;
		};
		dailyCount: any;
	};
	translationObject: any;
}

const DescriptionSection: React.FC<IDescriptionSectionProps> = ({
	dashboardObject,
	translationObject,
}) => {
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();
	const currentPlan = useSelector(getCurrentPlan);
	return (
		<DescriptionSectionWrapper>
			<DescriptionUpperWrapper>
				<DescriptionUpperTitleWrapper>
					<DescriptionUpperTitleImage>
						<img
							src={application_icon}
							alt="사진없음"
							style={{ width: "90%" }}
						/>
					</DescriptionUpperTitleImage>
					<DescriptionUpperTitleText>
						{dashboardObject.name}
					</DescriptionUpperTitleText>
				</DescriptionUpperTitleWrapper>
				<SettingButton
					endIcon={
						<img src={ic_Group} alt="사진없음" style={{ height: "20px" }} />
					}
					onClick={(e) => {
						history.push(`/application/${dashboardObject.id}/setting`);
					}}
				>
					{translationObject("application_detail.setting")}
				</SettingButton>
			</DescriptionUpperWrapper>
			<DescriptionUnderWrapper>
				{currentPlan?.paymentPlan && (
					<DescriptionUnderContentWrapper>
						<DescriptionUnderContentTitle>
							{translationObject("application_detail.plan_name")}
						</DescriptionUnderContentTitle>
						<DescriptionUnderContentPlan>
							{currentPlan.paymentPlan.title}
						</DescriptionUnderContentPlan>
						{/* <DescriptionUnderContentDeadline>
							{currentPlan.paymentPlan.remainingDays}일 남음
						</DescriptionUnderContentDeadline> */}
					</DescriptionUnderContentWrapper>
				)}
				<DescriptionUnderContentWrapper>
					<DescriptionUnderContentTitle>
						{translationObject("application_detail.package_android")}
					</DescriptionUnderContentTitle>
					<DescriptionUnderContentDate>
						{dashboardObject.packageAndroid}
					</DescriptionUnderContentDate>
					<CopyToClipboard
						text={dashboardObject.packageAndroid}
						onCopy={() => {
							enqueueSnackbar(
								translationObject(
									"application_detail.clip_board_copy_package_name_android",
								),
								{ variant: "info" },
							);
						}}
					>
						<img
							src={clipboard}
							alt="사진없음"
							style={{ cursor: "pointer" }}
						/>
					</CopyToClipboard>
				</DescriptionUnderContentWrapper>
				<DescriptionUnderContentWrapper>
					<DescriptionUnderContentTitle>
						{translationObject("application_detail.created_at")}
					</DescriptionUnderContentTitle>
					<DescriptionUnderContentDate>
						{dashboardObject.createdAt &&
							createTimeFormat(dashboardObject.createdAt)}
					</DescriptionUnderContentDate>
				</DescriptionUnderContentWrapper>
				<DescriptionUnderContentWrapper>
					<DescriptionUnderContentTitle>
						{translationObject("application_detail.package_ios")}
					</DescriptionUnderContentTitle>
					<DescriptionUnderContentDate>
						{dashboardObject.packageIos}
					</DescriptionUnderContentDate>
					<CopyToClipboard
						text={dashboardObject.packageIos}
						onCopy={() => {
							enqueueSnackbar(
								translationObject(
									"application_detail.clip_board_copy_package_name_ios",
								),
								{ variant: "info" },
							);
						}}
					>
						<img
							src={clipboard}
							alt="사진없음"
							style={{ cursor: "pointer" }}
						/>
					</CopyToClipboard>
				</DescriptionUnderContentWrapper>
				<DescriptionUnderContentWrapper>
					<DescriptionUnderContentTitle>
						{translationObject("application_detail.expired_at")}
					</DescriptionUnderContentTitle>
					<DescriptionUnderContentDate>
						{dashboardObject.expiredAt
							? createTimeFormat(dashboardObject.expiredAt)
							: "-"}
					</DescriptionUnderContentDate>
					{/* {currentPlan?.paymentPlan && (
						<DescriptionUnderContentDeadline>
							{currentPlan.paymentPlan.remainingDays}일 남음
						</DescriptionUnderContentDeadline>
					)} */}
				</DescriptionUnderContentWrapper>
			</DescriptionUnderWrapper>
		</DescriptionSectionWrapper>
	);
};

export default DescriptionSection;
